import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { getExtensionFile, getNameInCapitalize } from "../../utils/common";
import moment from "moment";
import { DATE_FORMAT_DEFAULT } from "../../utils/constants";
import {
    EmptyText,
    RichText,
    WordBreak,
} from "../common/CellText";
import FileItem from "../FileItemComponent/FileItem";
import LinkedTask from "../Linked/LinkedTask";
import LinkedWork from "../Linked/LinkedWork";
import PeopleTag from "../PeopleTag";

const HandlerModal = ({ open, handleClose, handler,headerTitle='Người xử lý' }) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={"paper"}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            className="doc-popup"
            fullWidth
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100vw",
                        maxWidth: "100vw", // Set your width here
                        mx: 0,
                    },
                },
            }}
        >
            <DialogTitle
                id="scroll-dialog-title"
                className="text-xl font-bold text-[#23374D] !pt-8"
                sx={{
                    fontWeight: 700,
                }}
            >
                <span className="font-bold">{headerTitle}</span>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="scroll-dialog-description"
                    tabIndex={-1}
                    className="min-h-[150px] mt-4"
                >
                    <div className="flex flex-wrap gap-3">
                        {handler?.map((item) => (
                            <PeopleTag el={item} />
                        ))}
                    </div>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button
                    sx={{ fontWeight: 600 }}
                    onClick={handleClose}
                    className="pb-6 text-sm font-semibold leading-5 text-primary"
                >
                    Đóng
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default HandlerModal;
